import styled from 'styled-components'

export const FooterWrapper = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  gap: 24px;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0px;

  a {
    display: flex;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
    }
  }
`

export const Svg = styled.svg`
  height: 56px;
  width: auto;
  display: block;
`

export const BrandTitle = styled.h2`
  font-size: 1rem;
  font-weight: 600;
  color: ${p => p.theme.colors.dark};
  margin: 0;
  text-align: center;
  letter-spacing: 0.025em;
`

export const SocialContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 0px;
`

export const SocialText = styled.span`
  font-size: 0.875rem;
  color: #666;
  opacity: 0.85;
`

export const InstagramLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  img {
    display: block;
  }
`

export const Copyright = styled.p`
  font-size: 0.75rem;
  color: #999;
  margin: 0;
  text-align: center;
  line-height: 1.5;
  margin-top: 0px;
`

